import { EMPTY_OBJ } from '@constants';

import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useChannelsList = (queryVariables = {}, queryConfig = {}) => {
  const { data: channels = [], ...queryResult } = useResourceList(
    { name: 'channels', api: api.channels },
    { ...queryVariables, sort: queryVariables.sort || 'title' },
    queryConfig,
  );

  return {
    channels,
    ...queryResult,
  };
};

export const useChannel = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['channels', { id }], api.channels.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    channel: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'channels' });

export const useDeleteChannel = createMutation(api.channels.remove);

export const useCreateChannel = createMutation(api.channels.create);

export const useSaveChannel = createMutation(api.channels.save);

export const useUpdateChannel = createMutation(api.channels.update);
